export default "<div data-html-load=\"pagination-bottom\"></div>\n";